import { render, staticRenderFns } from "./desktopOptions.vue?vue&type=template&id=51551d31&"
import script from "./desktopOptions.vue?vue&type=script&lang=js&"
export * from "./desktopOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports